<template lang="html">
  <div class="startup_page" id="content" >
    <ConfirmModal :dialogVisible='showConfirmDialog' @close="closeConfirmDialog()" @confirmed="submitStartup($event)" message="Are you sure ? Once submitted, your selection will not be editable." ></ConfirmModal>
    <AddCommentModal :dialogVisible='dialog' @close="closeModal()" @newValueIsProposed="setNewValueComment($event)" formName="Add a comment" ></AddCommentModal>
    <BlockedModal :dialogVisible='showBockedDialog' @close="closeBlockedDialog()"  :formMessage="formMessage"></BlockedModal>

    <div class="container ">

      <div class="row startup" >
        <div class="col-12 startup_banner" v-if="startup_image">
             <img :src="this.apiUrl+'/get_image/'+startup_image+'?token='+$store.state.innotoken" alt="" class="startup_banner" v-if="startup_image">
             <div class="startup_logo" v-if="startup_logo">
               <div class="startup_logo_inside">
                 <div class="" v-if="startup_logo">
                   <img :src="this.apiUrl+'/get_image/'+startup_logo+'?token='+$store.state.innotoken" alt="" class="" v-if="startup_logo">
                 </div>


               </div>

             </div>

        </div>
     <div class="pad0" v-if="startup_logo">
          <div class="startupName"  v-if="startup" style="padding-top:100px;">
              <!--  {{startup.name}} -->
          </div>

        </div>
            <!--
        <div class="pad0" v-else>
          <div class="startupName"  v-if="startup">
            {{startup.name}}
          </div>

        </div> -->

        <div class="action_zone">
          <span class="actionZoneTitle">Choose your action</span>
         <!-- <router-link class="prev_step_btn_small" v-if="selected_filters.length > 0" :to="'/startup_with_filters_graph/'+this.$route.params.search_field+'/'+JSON.stringify(selected_filters)+'/'+this.$route.params.pid">Graph view</router-link> -->
         <div class="goRight">
           <div class="zoneBtn" >
             <button type="button" class="action_btn"  name="button" @click="openModal()">Add a comment</button>

           </div>
           <div class="zoneBtn" :class="(assessment.isSubmit == true) ? 'enableWhyDisabled' :'ok'">
             <button type="button" class="action_btn" :class="(assessment.isSubmit == true) ? 'disabledRlink' :'ok'" name="button" @click="saveStartupAssessment" :disabled="assessment.isSubmit == true">Save</button>
             <span class="whyDisabled">
               <span>This assessment has been submitted. If you want to add or correct anything, please contact your account manager. </span>
             </span>
           </div>
           <div class="zoneBtn" :class="(assessment.isSubmit == true) ? 'enableWhyDisabled' :'ok'">
             <button type="button" class="action_btn" :class="(assessment.isSubmit == true) ? 'disabledRlink' :'ok'" name="button" @click="confirmValid()" :disabled="assessment.isSubmit == true">Confirm</button>
             <span class="whyDisabled">
               <span>This assessment has been submitted. If you want to add or correct anything, please contact your account manager. </span>
             </span>
           </div>



           <!-- <div class="add_comment col-12 text-right">
               <button type="button" class="add_new_comment" @click='openModal()' name="button">
                 <img :src="require('@/assets/comments.svg')" alt="">
                 Add a comment</button>
           </div> -->

         </div>

       </div>
        <div class="content_div" >

          <div class="row dflex revese pl20">

            <div class="col-12 col-lg-6 col-xl-8 force50 force100">
              <h5 class="tblue"><strong>Summary</strong></h5>
              <StartupInfoLine v-if="startup.application_area" class="noBorder" className="inHeader" name="Application domain" :value="startup.application_area"  :isArray="Array.isArray(startup.application_area)"/>
              <StartupInfoLine v-else name="Application domain" class="noBorder" className="inHeader" value="No data" />

              <StartupInfoLine v-if="startup.value_proposition" class="noBorder" className="inHeader" name="Value proposition" :value="startup.value_proposition"  :isArray="Array.isArray(startup.value_proposition)"/>
              <StartupInfoLine v-else name="Value proposition" class="noBorder" className="inHeader" value="No data" />

              <StartupInfoLine v-if="startup.solution" name="solution" className="inHeader" class="noBorder" :value="startup.solution"/>
              <StartupInfoLine v-else name="solution" class="noBorder" className="inHeader" value="No data" />


              <StartupInfoLine v-if="startup.funding_stage" name="Funding stage" className="inHeader" class="noBorder" :value="startup.funding_stage"/>
              <StartupInfoLine v-else name="Funding stage" class="noBorder" className="inHeader" value="No data" />

              <StartupInfoLine v-if="startup.no_revenue_yet" class="noBorder" className="inHeader" name="Revenue" value="No revenue yet" />

                <StartupInfoLine v-else-if="startup.revenue" class="noBorder" className="inHeader" name="Revenue" :value="startup.revenue" :isCurrency="true"/>
                <StartupInfoLine v-else name="Revenue" class="noBorder"  className="inHeader" value="No data" />

              <StartupInfoLine v-if="startup.team_size" class="noBorder"  className="inHeader" name="Team size" :value="startup.team_size"/>
              <StartupInfoLine v-else  name="Team size"  class="noBorder" className="inHeader" value="No data" />

                <StartupInfoLine v-if="startup.location" class="noBorder" className="inHeader" name="Location" :isLocation="true" :value="startup.location" :isArray="Array.isArray(startup.location)"/>
                <StartupInfoLine v-else name="Location"  class="noBorder" className="inHeader" value="No data" />

            </div>
            <div class="col-12 col-lg-6 col-xl-4 force50">
              <h5 class="tdore fs30 text-center"><strong>{{startup.name}}</strong></h5>
              <div class="contactZone mt20" v-if="startup.key_contact_name || startup.key_contact_email || startup.website">
                <div class="mb20 dflexcontact">
                  <div class="contactIcon"><v-icon icon="mdi:mdi-account-circle-outline" /></div>
                  <div class="">
                    <h5><strong>Key contact</strong></h5>
                    <span class="contactInfo_kcn" v-if="startup.key_contact_name">{{startup.key_contact_name}}</span>
                  </div>

                </div>

                  <ul class="contactInfoList">
                    <li class="contactInfoItem" v-if="startup.key_contact_email">
                      <a :href="'mailto:'+startup.key_contact_email">{{startup.key_contact_email}}</a>
                    </li>
                    <li class="contactInfoItem" v-if="startup.key_contact_phone">
                      <a :href="'tel:'+startup.key_contact_phone">{{startup.key_contact_phone}}</a>
                    </li>
                    <li class="contactInfoItem" v-if="startup.website">
                      <a :href="website_formated" target="_blank">{{ getBaseUrl(startup.website) }}</a>
                    </li>

                  </ul>
              </div>
            </div>
          </div>
          <!-- <div class="col-12" >
               <img :src="this.apiUrl+'/get_image/'+startup_image+'?token='+$store.state.innotoken" alt="" class="startup_banner" v-if="startup_image">
               <img src="https://www.innopearl.ch/wp-content/uploads/2022/12/inn_header-accelerator.jpg" class="startup_banner" alt="" v-else>

          </div> -->
          <div class="row mt50">
            <div class="col-12 " v-if="startup">

                <StartupInfoTab :startup="startup" :isRestrict="false"/>


              </div>
          </div>



      <div class="assessment" >
        <div class="row">
          <div class="col-12 col-xl-4 mt20">
            <div class="item_card">
              <span class="item_card_title">READINESS FOR PARTNERSHIP</span>
              <div class="item_card_content"  v-if="assessment.readiness_for_partnership">
                <img :src="this.apiUrl+'/get_image/'+assessment.readiness_for_partnership.$oid+'?token='+$store.state.innotoken" @click="visibleRef_readiness = true"  class="img-fluid" alt="">
                <vue-easy-lightbox :rotateDisabled='true' :visible="visibleRef_readiness" :imgs="this.apiUrl+'/get_image/'+assessment.readiness_for_partnership.$oid+'?token='+$store.state.innotoken"  @hide="onHide" ></vue-easy-lightbox>
              </div>
              <div class="item_card_content" v-else>
                <div class="alert alert-info text-center">Not available</div>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-4 mt20">
            <div class="item_card">
              <span class="item_card_title">ANALYTICAL SUPPORT</span>
              <div class="item_card_content"  v-if="assessment.analytical_support">
                <img :src="this.apiUrl+'/get_image/'+assessment.analytical_support.$oid+'?token='+$store.state.innotoken" @click="visibleRef_analytical_support = true"  class="img-fluid" alt="">
                <vue-easy-lightbox :rotateDisabled='true' :visible="visibleRef_analytical_support" :imgs="this.apiUrl+'/get_image/'+assessment.analytical_support.$oid+'?token='+$store.state.innotoken"  @hide="onHide" ></vue-easy-lightbox>
              </div>
              <div class="item_card_content" v-else>
                <div class="alert alert-info text-center">Not available</div>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-4 mt20">
            <div class="item_card">
              <span class="item_card_title">STRATEGIC FIT</span>
              <div class="item_card_content" v-if="assessment.strategic_fit">
                <img :src="this.apiUrl+'/get_image/'+assessment.strategic_fit.$oid+'?token='+$store.state.innotoken"  class="img-fluid assessment_report" alt="" @click="visibleRef_strategic_fit = true">
                <vue-easy-lightbox :rotateDisabled='true' :visible="visibleRef_strategic_fit" :imgs="this.apiUrl+'/get_image/'+assessment.strategic_fit.$oid+'?token='+$store.state.innotoken"  @hide="onHide"></vue-easy-lightbox>
                </div>
              <div class="item_card_content" v-else>
                <div class="alert alert-info text-center">Not available</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt50"  v-if="assessment.assessment_report">
          <div class="col-12 text-center">
            <a :href="this.apiUrl+'/get_image/'+assessment.assessment_report.$oid+'?token='+$store.state.innotoken" target="_blank" class="changeImage_relative_outline" alt="" >
              See the 360° assessment report
            </a>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 divider-dotted">

        </div>
      </div>
      <div class="row center mb50">
          <div class="col-12 col-xl-6 mt50">
            <div class="flex">
              <div class="barLabel">
                <span>My interest level</span>
              </div>
              <div class="barcontainer">
                <div :class="'bar '+assessment.collab_interest_level">
                </div>
                <div class="jauge" >
                    <label for="low" class="jauge_label low">
                      <input type="radio" id="low" value="low" v-model="assessment.collab_interest_level" :disabled="assessment.isSubmit" />
                      <div class="info">
                        <span>Low</span>
                        <small>No Interest</small>
                      </div>
                    </label>
                    <label for="medium"  class="jauge_label medium">
                      <input type="radio" id="medium" value="medium" v-model="assessment.collab_interest_level" :disabled="assessment.isSubmit" />
                      <div class="info">
                        <span>Medium</span>
                        <small>Consider for later</small>
                      </div>
                    </label>
                    <label for="high"  class="jauge_label high">
                      <input type="radio" id="high" value="high" v-model="assessment.collab_interest_level"  :disabled="assessment.isSubmit"/>
                      <div class="info">
                        <span>High</span>
                        <small>Progress now</small>
                      </div>

                    </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-6 mt50">
            <div class="flex">
                <div class="barLabel">
                <span>Select for introduction ?</span>
              </div>
              <div class="">
                <label class="rocker ">
                  <input type="checkbox" v-model="assessment.select_for_introduction" :disabled="assessment.isSubmit">
                  <span class="switch-left">YES</span>
                  <span class="switch-right">NO</span>
                </label>
              </div>
            </div>
          </div>
          <div class="col-12 mt50">
            <div class="candidate_links candidate_comments" style="border:1px solid #CCC;padding:20px;">
              <div  v-if="assessment.comments">
                <div class="barLabel">
                <span>Comment<span v-if="assessment.comments.length > 1">s</span></span>
              </div>

               <div class="comments_list"  v-if="assessment.comments">
                  <div class="one_comment" v-for="(comment, i) in assessment.comments" :key="i">
                    <span v-if="comment.value"> <strong v-if="comment.by">{{comment.by}} : </strong><span v-html="comment.value"></span></span>
                        <span v-else>{{comment}}</span>
                  </div>

              </div>
                  </div>
              <div class="add_comment col-12 text-right">
                  <button type="button" class="add_new_comment" @click='openModal()' name="button">
                    <img :src="require('@/assets/comments.svg')" alt="">
                    Add a comment</button>
              </div>
            </div>
          </div>
          <div class="col-12 text-center mt50" v-if="assessment.isSubmit != true">
            <button type="button" name="button" class="next_step_btn" @click='saveStartupAssessment()'>
              SAVE
            </button>
            <button type="button" name="button" class="next_step_btn" @click='confirmValid'>
              CONFIRM
              <img :src="require('@/assets/next.svg')" alt="">
            </button>
            <div class="col-12" v-if="assessment.lastEdit" style="margin-top:20px;">
              Last modification date: {{assessment.lastEdit.date}}
            </div>
          </div>
            <div class="col-12 text-center mt50" v-else>
                <div class="alert alert-info mt50" v-if="assessment.isSubmit">
                  This assessment has been submitted. If you want to add or correct anything, please contact your account manager.
                </div>
            </div>
      </div>


      <div class="row">
        <div class="col-12 divider-dotted">

        </div>
      </div>

      <div class="row center mt50">
        <div class="col-12 col-xl-6">
          <button  v-if="canGoBack" class="prev_step_btn" @click="gobackrouter()" >
            <img :src="require('@/assets/prev.svg')" alt="">
            BACK TO YOUR SELECTION
          </button>
        </div>
        <div class="col-12 col-xl-6 text-xl-right">
          <a class="prev_step_btn"  v-if="assessment.report"  target="_blank" :href="this.apiUrl+'/get_image/'+assessment.report.$oid+'?token='+$store.state.innotoken">
            <img :src="require('@/assets/greyDownload.svg')" alt="">
            Download full report
          </a>
        </div>
      </div>
    </div>

    </div>

  </div>
  </div>
</template>

<script>
import StartupInfoLine from '@/components/InfoStartupLine.vue'
// import StartupFounders from '@/components/StartupFounders.vue'
import { toast } from 'vue-sonner'
import api from '../tools/api';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import AddCommentModal from '@/components/modals/addComment.vue'
import StartupInfoTab from '@/components/StartupInfoTab.vue';
import BlockedModal from '@/components/modals/blockedModal.vue'
export default {
  name : "StartupInfo",
  components: {
     StartupInfoLine,
    // StartupFounders,
    ConfirmModal,
    AddCommentModal,
    StartupInfoTab,
    BlockedModal
  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      blockSaveAndSubmit: false,
      formMessage: "",
      showBockedDialog:false,
      assessment_id : null,
      assessment_submit : false,
      assessment: {},
      startup : {location:[]},
      visibleRef_readiness: false,
visibleRef_analytical_support: false,
visibleRef_strategic_fit: false,
showConfirmDialog: false,
dialog:false,
    }
  },
  computed:{
    canGoBack() {
      // console.log("router");
      // console.log(this.$router.currentRoute.matched);
      // console.log(window.history);
      //return this.$router.history.length > 1;
      if(window.history)
        if(window.history.length > 1)return true;
      return false;

    },
    startup_logo: function(){
      if(this.startup.logo){
        console.log(this.startup.logo);
        return this.startup.logo.$oid;
      }
      else{
        return null;
      }

    },
    website_formated: function(){
      if(this.startup.website){
        if(this.startup.website.startsWith("https://") || this.startup.website.startsWith("http://")){
          return this.startup.website;
        }
        else{
          return "https://"+this.startup.website;
        }
      }
      else{
        return null;
      }

    },
    startup_image: function(){
      if(this.startup.image){
        console.log(this.startup.image);
        return this.startup.image.$oid;
      }
      else{
        return null;
      }

    }
  },
  methods:{
    closeBlockedDialog: function(){
      this.showBockedDialog = false;
    },
    closeModal(){
      this.dialog = false;
    },
    openModal(){
      this.dialog = true;
    },
    confirmValid(){
            this.locker().then(() => {
            if(this.blockSaveAndSubmit == false){
                this.showConfirmDialog = true;
            }
          });

    },
    getBaseUrl(url){
      var formated = url.replace(/^https?:\/\//, '').replace(/\/$/, '');
      try{
        var r= new URL(url).origin;
        r = r.replace(/^https?:\/\//, '').replace(/\/$/, '');
        return r;
      }catch{
        return formated;
      }
    },
    setNewValueComment(v){
      if(v){
        console.log(v);
        api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/assessment/candidate/add_comment",
        {
          comment : v,
          candidate : {startup_id : this.startup._id},
          sf:this.$route.params.searchfield,
        },
        {
          headers: {
              'Content-Type': 'application/json',
        }
      }).then( (r) => {
        console.log(r);
        toast.success("Your comment is added");
        if(!this.assessment.comments)this.assessment.comments = [];
          this.assessment.comments.push(r.data);
      }).catch( () => {
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
      });

      }

      this.dialog = false;
    },

    gobackrouter : function(){
      this.$router.go(-1);
    },
    closeConfirmDialog(){
      this.showConfirmDialog = false;
    },
    submitStartup(){
      this.showConfirmDialog =false;
      api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/submit_assessement/"+this.$route.params.searchfield,
          {
              value: this.assessment
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
      }).then( (r) => {
        console.log(r);
          toast.success("Your selection is saved")
          this.assessment.isSubmit = true;
      }).catch( (e) => {
        console.log(e);
            toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
      });
    },
    onHide(){
      this.visibleRef_readiness = false;
      this.visibleRef_analytical_support =false;
      this.visibleRef_strategic_fit = false;
    },
    saveStartupAssessment(){
      if(this.blockSaveAndSubmit == false){
        this.locker().then(() => {
          console.log("dfqsfqsfqdsfqdsf");


        if(this.blockSaveAndSubmit == false){
          api.post(process.env.VUE_APP_API_URL+"/search_field/save_assessement/"+this.$route.params.searchfield,
              {
                  value: this.assessment
              },
              {
                headers: {
                    'Content-Type': 'application/json',
              }
          }).then( (r) => {
            console.log("data",r);
              toast.success("Your selection has been saved!")
          }).catch( (e) => {
            console.log(e);
                toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
          });
        }
          });
      }

    },
    async locker(){
     await  api.get(process.env.VUE_APP_API_URL+"/restrict/assessment_report/"+this.$route.params.searchfield+'/'+this.$route.params.startup).then( (r) => {

        var d = r.data.candidate_to_assess;
        console.log(d);
             if(d.locked){
                 if(this.$store.state.uid != d.locked.user.$oid){
                      this.blockSaveAndSubmit = true;
                      var plural = (d.locked.expireDuration.toFixed() > 1) ? 's.' : ".";
                      var duration = (d.locked.expireDuration.toFixed() > 0) ? d.locked.expireDuration.toFixed() : "less than 1";
                      console.log(duration);
                      this.formMessage = d.locked.fullUser.firstname+" "+d.locked.fullUser.lastname+" is working on this project right now. Please wait for  "+duration+" minute"+plural+" before making any changes. ";

                      // this.formMessage = d.locked.fullUser.firstname+" "+d.locked.fullUser.lastname+" is currently working on this ressource. You can't save or submit data for "+duration+" minute"+plural;
                    //  this.showBockedDialog = true;
                      toast.error(this.formMessage);

                 }
                 else{
                           this.blockSaveAndSubmit = false;
                        ////    this.showBockedDialog = false;
                          }
             }
             return "";
      })
    }
  },
  mounted(){
    api.get(process.env.VUE_APP_API_URL+"/restrict/assessment_report/"+this.$route.params.searchfield+'/'+this.$route.params.startup).then( (r) => {
      // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
      // console.log();
      console.log("log",r);

      this.startup = r.data.candidate_to_assess.startup
      if(!this.startup.investment_raised)this.startup.investment_raised = {
        value : 0,
        unit:null,
        currency: null
      }
      if(!this.startup.market_potential)this.startup.market_potential = {
        value : 0,
        unit: null,
        currency: null
      }
      if(!this.startup.last_funding_round)this.startup.last_funding_round = {
        value : 0,
        unit: null,
        currency: null
      }

      if(!this.startup.revenue)this.startup.revenue = {
        value : 0,
        unit: null,
        currency: null
      }
      if(!this.startup.growth)this.startup.growth = {
        m12 : null,
        m6: null,
        m3: null
      }
      if(!this.startup.location)this.startup.location = [];
      this.project = r.data.project;
      this.assessment = r.data.candidate_to_assess
      this.assessment._id = r.data._id.$oid;
      this.assessment_id = r.data._id.$oid;
      this.assessment.lastEdit = (r.data.lastEdit) ? r.data.lastEdit : null;
      this.assessment_submit = r.data.isSubmit;

      if(this.assessment.locked){
        console.log("locked",this.assessment.locked);
        console.log("current u ",this.$store.state.uid);
        console.log("locked by ",this.assessment.locked.user);
        console.log("condiftion ",(this.$store.state.uid != this.assessment.locked.user.$oid));
          if(this.$store.state.uid != this.assessment.locked.user.$oid){
               this.blockSaveAndSubmit = true;
               var plural = (this.assessment.locked.expireDuration.toFixed() > 1) ? 's.' : ".";
               var duration = (this.assessment.locked.expireDuration.toFixed() > 0) ? this.assessment.locked.expireDuration.toFixed() : "less than 1";
               console.log(duration);
               this.formMessage = this.assessment.locked.fullUser.firstname+" "+this.assessment.locked.fullUser.lastname+" is working on this project right now. Please wait for  "+duration+" minute"+plural+" before making any changes. ";

    //           this.formMessage = this.assessment.locked.fullUser.firstname+" "+this.assessment.locked.fullUser.lastname+" is currently working on this ressource. You can't save or submit data for "+duration+" minute"+plural;
               this.showBockedDialog = true;
          }
          else{
                    this.blockSaveAndSubmit = false;
                     this.showBockedDialog = false;
                   }
      }

    }).catch( (e) => {
    if(e.response.status == 403)toast.error("To request access to this resource, please contact us");
    else toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
  });
  }
}
</script>

<style lang="css" scoped>
.startup_page{
  padding-top:50px;
  padding-bottom: 50px;
  padding: 50px;
}
.startup{
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.content_div{
  /* margin-top:50px;
  margin-bottom: 50px; */
  padding: 50px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-bottom-left-radius: 8px;
border-bottom-right-radius: 8px;
}
.startup_name{
  color: #3783C5;
text-transform: uppercase;
font-size:24px;
line-height: 29px;
}
.startup_website{
margin-top: 10px;

}
.startup_website a{
  font-size:16px;
  line-height: 22px;
  text-decoration: none;
  color: #000;

}
.startup_website img{
  margin-right: 10px;
}
.startup_banner_container{
  width:100%;
  padding:0;
}
img.startup_banner{
  width: 100%;
  height: 350px;
  object-fit: cover;
  object-position: center;
}

.assessment{
  margin-bottom: 100px;
}
.item_card{
  border: 1px solid #DDD;
  border-radius: 10px;
padding: 20px;
position:relative;
padding-top: 40px;
margin-top: 20px;
align-content: center;
align-items: center;
align-self: center;
justify-content: center;
display: flex;
height:100%;
}
.item_card .item_card_title{
  position:absolute;
  top: 0px;
  transform: translateY(-50%);
  left: 20px;
  background: #FFF;
  color: #3783C5;
text-transform: uppercase;
font-size:18px;
line-height: 24px;
  padding-left: 20px;
  padding-right: 20px;
}






.barcontainer{
  background-color: #DDDDDD;
  position: relative;
  margin-left: 50px;
  width: 30px;
  height: 200px;
}
.bar{
  background-color: #3783C5;
  position: absolute;
  bottom: 0;
  width: 100%;

  box-sizing: border-box;
  -webkit-transition: all 0.5s linear;
      -moz-transition: all 0.5s linear;
      -o-transition: all 0.5s linear;
      transition: all 0.5s linear;
  transform-origin: bottom;
}
.bar.low{
  height: 10%;
}
.bar.medium{
  height: 50%;
}

.bar.high{
  height: 90%;

}

@keyframes grow{
  from{
    transform: scaleY(0);
  }
}

.jauge_label.low{
  position: absolute;
  bottom :10%;
  transform: translateY(50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}

.jauge_label.medium{
  position: absolute;
  bottom :50%;
  transform: translateY(50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}


.jauge_label.high{
  position: absolute;
  top :10%;
  transform: translateY(-50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}

.jauge_label::before{
  content :" ";
  background: #707070;
  width:10px;
  height:1px;
  left: -10px;
  position:absolute;
  top: 50%;
}
.jauge_label input{
  width:22px;
  height:22px;
}

.jauge_label span{
  display:block;
  color: #3783C5;
  font-size: 14px;
  line-height: 22px;
  width:100%;
  font-weight: 500;
  text-transform:uppercase;
}
.jauge_label small{
  color: #575757;
  font-weight: 300;
  font-size:14px;
  line-height: 22px;
}
.info{
    display: flex;
    flex-direction: column;
    padding: 5px;
}

.flex{
  display:flex;
  align-items: center;
    gap: 20px;
}
.barLabel{
  color: #3783C5;
  font-size:18px;
  line-height: 21px;
}
@media screen and (max-width:1200px){
  .flex{
    flex-direction: column;

    align-items: flex-start;
  }
}

.rocker input{
  display: none;
}
.rocker{
  border: 1px solid #3783C5;
border-radius: 200px;padding:5px;
}
.rocker .switch-left{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker .switch-right{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker input:checked + .switch-left {
  background:#3783C5;
  color: #FFF;
  border-radius: 50px 0 0 50px;
}
.rocker input:not(:checked)+ .switch-left  + .switch-right {
  background:#3783C5;
  color: #FFF;
  border-radius: 0 50px 50px 0  ;
}

.center{
  align-items: center;
}

.mt50{
  margin-top: 50px;
}
.mb50{
  margin-bottom: 50px;
}

.divider-dotted{
  border-bottom:1px dashed #3783C5;
}

.next_step_btn{
  background: #3783C5 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3783C5;
  border-radius: 200px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}
.next_step_btn img.left{
  margin-right:10px;
}

.prev_step_btn{
  border: 1px solid #3783C5;
  border-radius: 200px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
  margin:5px;
}
.prev_step_btn img{
  margin-right:10px;
}

.prev_step_btn{
  text-decoration :none;
}
.contact_step_btn{
  border: 1px solid #575757;
  border-radius: 200px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  background:#575757;
  margin:5px;
  text-decoration: none;
}

@media screen and (max-width: 690px){
  .startup_page{
    padding-left:15px;
    padding-right: 15px;
  }
  .content_div{
    padding-right: 20px;
    padding-left: 20px;
  }
}.changeImage_relative_outline{
  text-decoration: none;
  color:#3783C5;
  border: 1px solid #3783C5;
  padding:15px 20px;
  display:inline-block;
  text-transform: uppercase;
  margin:10px;
  margin:auto;
  text-align: center;

}

.vel-img {
  background:#FFF !important;
}

.candidate_comments{
  padding: 20px 50px;
  border-top: 1px solid #DDD;
  margin-top:auto;
}
.candidate_comments .one_comment{
  margin-top:10px;
  margin-bottom: 10px;
  font-size:12px;
  line-height:15px;
    position:relative;
}
.candidate_comments .one_comment:after {
  content: ""; /* This is necessary for the pseudo element to work. */
     display: block; /* This will put the pseudo element on its own line. */
     margin: 0 ; /* This will center the border. */
     width: 100px; /* Change this to whatever width you want. */
     padding-top: 10px; /* This creates some space between the element and the border. */

     border-bottom: 1px solid #CCC; /* This creates the border. Replace black with whatever color you want. */
}
.candidate_comments small{
  font-size:12px;
}
.mt20{
  margin-top:20px !important;
}
.add_new_comment{
  font-size:12px;
  line-height:15px;
  color: #3785C5;
  text-transform: uppercase;
  margin-top:20px;
}
.add_new_comment img{
  width: 20px;
  margin-right: 10px;
}
.jauge_label{
  text-align:left !important;
}




.action_zone{
  position: sticky;
    right: 0;
    top: 0;
    background: #4C81C0;
    padding: 20px 50px;
    z-index:889;
    display:flex;
    flex-wrap:wrap;

}
.actionZoneTitle{
  color: #FFF;
  font-weight: bold;
  font-size: 20px;
    text-transform: uppercase;
}

.contactZone{
  border:2px solid #B38D2F;
  border-radius: 10px;
  padding:20px 50px;
  width:auto;
}
.tdore{
  color: #B38D2F !important;
}
@media screen and (max-width:1000px){
  .contactZone{
    margin-top:20px;
  }
}
.contactZone h5{
  display:block;
  color: #4C81C0 !important;
}
.contactInfo{
  display: flex;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  color: #4C81C0 !important;
  font-weight: 600;
}
.contactInfo{
  display: flex;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  color: #000 !important;
  font-weight: 600;
}
.startupName{
  width:100%;
  text-transform: uppercase;
  color:#4C81C0;
  font-weight: bold;
    padding:20px 50px;
    font-size: 25px;
  background:#FFF;
}


.action_btn,
.action_btn:hover{
  background: #FFF;
  color: #000;
  padding: 5px 15px;
  font-weight: 600;
  border-radius: 200px;
}
.disabledRlink{
  pointer-events: none;
  opacity: 0.7;
}

.zoneBtn{
  position:relative;
  display: flex;

}


.whyDisabled{
  position: absolute;
  background: #EFEFEF;
  padding: 5px;
  width: 120px;
  left: 0px;
  bottom: -5px;
  -webkit-transform: translateY(100%);
  transform: translateY(100%);
  font-size:12px;
  display:none;
}

.enableWhyDisabled:hover .whyDisabled{
  display:block;
}

.hoverInfo{
  position: absolute;
  background: #EFEFEF;
  color:#000 !important;
  padding: 5px;
  width: 120px;
  left: 0px;
  bottom: -5px;
  -webkit-transform: translateY(100%);
  transform: translateY(100%);
  font-size:12px;
  display:none;
}

.goRight{
  margin-left:auto;
  display:flex;
  flex-wrap:wrap;
  gap:20px;
}


.startup_banner{

  position:relative;
  height:300px;
  background:#fff;
  padding: 0 !important;
}
.startup_banner img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.startup_logo{
  width: 300px;
    height: 150px;
    position: absolute;
    left: 50px;
    bottom: -75px;
    z-index: 999;

}
.startup_logo img{
  width: 300px;
    height: 150px;
    object-fit: contain;
    padding:10px;
}
.startup_logo .alt{
  width: 300px;
    height: 150px;

}
.startup_logo_inside{
  position:relative;
  -webkit-box-shadow: 0px 0px 20px -4px #CCC;
  box-shadow:0px 0px 20px -4px #CCC;
  background:#FFF;
}
.pad0{
  padding:0;
}

.pl20{
  padding-left:20px !important;
}
.tblue{
    color: #4C81C0 !important;
}



.action_zone{
  position: sticky;
    right: 0;
    top: 0;
    background: #4C81C0;
    padding: 20px 50px;
    z-index:889;
    display:flex;
    flex-wrap:wrap;

}
.actionZoneTitle{
  color: #FFF;
  font-weight: bold;
  font-size: 20px;
  text-transform: uppercase;
}

.contactZone{
  border:2px solid #B38D2F;
  border-radius:10px;
  padding:20px 50px;
  width:auto;
}
@media screen and (max-width:1000px){
  .contactZone{
    margin-top:20px;
  }
}
.tdore{
  color: #B38D2F !important;
}
.contactZone h5,
.content_div h5{
  display:block;
    color: #4C81C0 !important;
}
.contactInfo{
  display: flex;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  color: #4C81C0 !important;
  font-weight: 600;
}
.contactInfo a{
  color: #4C81C0 !important;
  font-weight: 600;
}
.contactInfo{
  display: flex;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  color: #000 !important;
  font-weight: 600;
}
.startupName{
  width:100%;
  text-transform: uppercase;
  color:#4C81C0;
  font-weight: bold;
    padding:20px 50px;
    font-size: 25px;
  background:#FFF;
}



.action_btn,
.action_btn:hover{
  background: #FFF;
  color: #000;
  padding: 5px 15px;
  font-weight: 600;
  border-radius: 200px;
}
.disabledRlink{
  pointer-events: none;
  opacity: 0.7;
  color: #666;
}

.zoneBtn{
  position:relative;
  display: flex;

}


.whyDisabled{
  position: absolute;
  background: #EFEFEF;
  padding: 5px;
  width: 120px;
  left: 0px;
  bottom: -5px;
  -webkit-transform: translateY(100%);
  transform: translateY(100%);
  font-size:12px;
  display:none;
}

.enableWhyDisabled:hover .whyDisabled{
  display:block;
}

.hoverInfo{
  position: absolute;
  background: #EFEFEF;
  color:#000 !important;
  padding: 5px;
  width: 120px;
  left: 0px;
  bottom: -5px;
  -webkit-transform: translateY(100%);
  transform: translateY(100%);
  font-size:12px;
  display:none;
}

.goRight{
  margin-left:auto;
  display:flex;
  flex-wrap:wrap;
  gap:20px;
}
.startup_banner{

  position:relative;
  height:300px;
  background:#fff;
  padding: 0 !important;
}
.startup_banner img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.startup_logo{
  width: 300px;
    height: 150px;
    position: absolute;
    left: 50px;
    bottom: -75px;
    z-index: 999;

}
.startup_logo img{
  width: 300px;
    height: 150px;
    object-fit: contain;
    padding:10px;
}
.startup_logo .alt{
  width: 300px;
    height: 150px;

}
.startup_logo_inside{
  position:relative;
  -webkit-box-shadow: 0px 0px 20px -4px #CCC;
  box-shadow:0px 0px 20px -4px #CCC;
  background:#FFF;
}
.pad0{
  padding:0;
}
.tblue{
    color: #4C81C0 !important;
}
.pl20{
  padding-left:20px !important;
}

.startup{
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}


.contactInfoItem{
  color:#B38D2F !important;
}
.contactInfoItem a,
.contactInfoItem a:hover,
.contactInfoItem span
{
  color:#FFF !important;
}
.contactInfo_kcn{
  color:#FFF;
  font-weight: 600;
    font-size:18px;
}

.contactInfoItem{
  margin-bottom: 10px;
}
.mb20{
  margin-bottom: 20px;
}

.contactZone .editContact{
  color:#FFF !important;
}

.dflexcontact{
  display:flex;
  gap:10px;
  align-items: center;
}

.contactIcon i{
  font-size: 30px;
    background: #3584C6;
    padding: 25px;
    color: #FFF;
    border-radius: 50%;
}
.contactInfoItem *{
  word-break:break-all;
}

.fblue{
  background: #3584C6;
    padding: 15px;
    color: #FFF;
    border-radius: 50%;
    margin-right: 10px;
    font-size: 15px;

}
.cmail a,
.cmail a:hover,
.ctel a,
.ctel a:hover{
    color:inherit;
}
.cmail i{
font-size:25px;
border-radius: 50%;
  margin-right: 10px;
}
.mr20{
      margin-right: 10px;
}
.crole{
  margin-left:20px;
}

.clinks{
  display:flex;
  gap:10px;
  justify-content: end;
}

.clinks i{

    background: #fff;
    border:1px solid #3584C6;
      padding: 15px;
      color: #3584C6;
      border-radius: 50%;
      font-size: 20px;


}

@media screen and (min-width:1200px) and (max-width:1700px){
  .force50{
    width:50% !important;
  }
}
@media screen and (max-width:1500px){
  .force100{
    margin-top:60px;
    width:100% !important;
  }
  .revese{
  flex-direction: column-reverse;
  }

}

.cn,
.ctel,
.cmail{
  width:30%;
}

@media screen and (max-width:1500px){
.respTable{
  display:flex;
  flex-direction: column;

}
.respTable td{
  width:100%;
  border:none;
}
.clinks{
  display:flex;
  gap:10px;
}
.respTable td:last-child{
  border-bottom:1px solid #ccc;
}
}

.listOfContacts{
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}
.listOfContacts .contactZone{
  width:calc(33% - 40px);
}

@media screen and (max-width:1500px){
  .listOfContacts .contactZone{
    width:calc(50% - 40px);
  }
}
@media screen and (max-width:990px){
  .listOfContacts .contactZone{
    width:100%;
  }
}

.tblue{
    color: #4C81C0 !important;
}
.tdore{
  color: #B38D2F !important;
}
.contactZone{
  border:2px solid #125AA4;
  background:#125AA4;
  border-radius: 10px;
  padding:20px 20px;
  width:auto;
  position:relative;
}
.contactZone h5{
  display: block;
  color: #fff !important;
  margin-bottom: 0;
  font-size:22px;
}

.fs30{
  font-size:30px;
}
</style>
